module.exports = __webpack_public_path__ + "static/media/9DESA3.97a319ab.jpg";